import { useMemo } from 'react'
import type { ImageSizeConfig } from '@fs/zion-rootstech'
import { useBrightspotImageSizes } from '../../../providers/BrightspotConfigProvider'

/**
 * Flattens the three image-size groups the calendar queries declare into the single flat
 * object Zion's calendar hooks spread into their GraphQL variables.
 *
 * The app groups sizes by field (`{ promoImage: { promoImage_width, ... } }`); Zion's
 * `ImageSizeConfig` is flat. Memoized because the result is an effect dependency inside
 * Zion's hooks — `useScheduleData` forwards it to three `useCalendarData` calls, so an
 * unstable reference would cost three refetch loops. Zion re-keys it off a serialized copy
 * as a backstop, but that's its guard against careless callers, not a reason to be one.
 */
export default function useCalendarImageSizes(): ImageSizeConfig {
  const { promoImage, thumbnailImage, profileImage } = useBrightspotImageSizes()

  return useMemo(
    () => ({ ...profileImage, ...promoImage, ...thumbnailImage }),
    [profileImage, promoImage, thumbnailImage]
  )
}
